import { createReducer, on } from '@ngrx/store';
import { loadListFailure, loadListSuccess, toggleLoadingStatus } from './portfolio-managers.actions';
import { initialUIState } from './portfolio-managers.state';

export const _uiReducer = createReducer(
  initialUIState,
  on(toggleLoadingStatus, (state, action) => ({
    ...state,
    isLoading: action.status,
  })),
  on(loadListFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),
  on(loadListSuccess, (state, action) => ({
    ...state,
    list: action.payload,
    isLoading: false,
  })),
);

export function uiReducer(state: any, action: any) {
  return _uiReducer(state, action);
}
